import { protoLib as lib } from '@tock/coretypes';

import coreDefs from '@tock/protos/dist/core.json';

import dashboardDefs from '@tock/protos/dist/dashboard.json';

const isTestEnv = process.env.NODE_ENV === 'test';

const registerProtoNamespace = (register: () => void) => {
  register();
};

const registerProtoNamespaceInTest = (register: () => void) => {
  try {
    register();
  } catch (error) {
    const isDuplicateNameError = error instanceof Error && error.message.includes('duplicate name');
    if (!isDuplicateNameError) {
      throw error;
    }
  }
};

const applyProtoRegistration = isTestEnv ? registerProtoNamespaceInTest : registerProtoNamespace;

applyProtoRegistration(() => {
  lib.define('tocktix.messages').addJSON(coreDefs.nested.tocktix.nested.messages.nested);
});
applyProtoRegistration(() => {
  lib
    .define('tocktix.proto.dashboard')
    .addJSON(dashboardDefs.nested.tocktix.nested.proto.nested.dashboard.nested);
});
const resolvedRoot = lib.resolveAll();

export default {
  ...resolvedRoot.lookup('tocktix.messages'),
  ...resolvedRoot.lookup('tocktix.messages.enums'),
  ...resolvedRoot.lookup('tocktix.proto.dashboard'),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;
